import {AsyncPipe, NgClass, NgComponentOutlet} from '@angular/common';
import {Component, inject}                     from '@angular/core';
import {DataAsstService}                       from '../../../../logr-services/asst/data-asst.service';
import {MenuPanelBase}                         from '../../utils/menu-panel-base';

@Component({
			   selector   : 'app-menu-drag',
			   imports    : [
				   NgClass,
				   AsyncPipe,
				   NgComponentOutlet
			   ],
			   templateUrl: './menu-drag.component.html',
			   styleUrl   : './menu-drag.component.css'
		   })
export class MenuDragComponent extends MenuPanelBase {

	svcAiData = inject(DataAsstService);
}
